import { render, staticRenderFns } from "./TransFinList.vue?vue&type=template&id=5a71ccc8&scoped=true&"
import script from "./TransFinList.vue?vue&type=script&lang=js&"
export * from "./TransFinList.vue?vue&type=script&lang=js&"
import style0 from "./TransFinList.vue?vue&type=style&index=0&id=5a71ccc8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71ccc8",
  null
  
)

export default component.exports